export default __webpack_public_path__ + "static/media/data.f88536ad.svg";